import ConsultaMultaView from '../views/consulta_multa/ConsultaMultaView.vue'
import ConsultaMultaDetalheView from '../views/consulta_multa/ConsultaMultaDetalheView.vue'
import ConsultaMultaDetalheViewCpfCnpj from '../views/consulta_multa/ConsultaMultaDetalheView.vue'
import PlacaRenavamView from '../views/consulta_multa/PlacaRenavamView.vue'
import CpfCnpjView from '../views/consulta_multa/CpfCnpjView.vue'
//import EmissaoGuiaPagamentoPlacaRenavamView from '../views/emissao_guia_pagamento/PlacaRenavamView.vue'
//import EmissaoGuiaPagamentoCpfCnpjView from '../views/emissao_guia_pagamento/CpfCnpjView.vue'

const multaRoutes = [
    {
        menu: true,
        titulo: 'Multa de trânsito',
        descricao: 'Guia de Pagamento, Cópia de Auto de Infração, Imagens do Radar, Notificações, Consulta de Processos (FICI, Defesa e Recursos) e outras informações',
        icone:{
            tipo: 'fa',
            nome:'magnifying-glass'
        },
        name: 'ConsultaMultaView',
        path: '/consulta-multa',
        component: ConsultaMultaView,
        meta:{
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Multa de trânsito',
                }
            ]
        }
    },
    {
        componentRoot: 'ConsultaMultaView',
        titulo: 'Consulta por Placa e RENAVAM',
        props: true,
        icone:{
            tipo: 'fa',
            nome:'car'
        },
        name: 'PlacaRenavamView',
        path: '/consulta-multa/placa-renavam',
        component: PlacaRenavamView, 
        meta:{
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Multa de trânsito',
                    to: '/consulta-multa'
                },
                {
                    text: 'Consulta por placa e RENAVAM',
                }
            ]
        }
    },

    {
        componentRoot: 'ConsultaMultaView',
        titulo: 'Consulta por CPF ou CNPJ do Proprietário',
        props: true,
        icone:{
            tipo: 'far',
            nome:'address-card'
        },
        name: 'CpfCnpjView',
        path: '/consulta-multa/cpf-cnpj',
        component: CpfCnpjView,
        meta:{
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Multa de trânsito',
                    to: '/consulta-multa'
                },
                {
                    text: 'Consulta por CPF ou CNPJ do Proprietário',
                }
            ]
        }         
    },

    {
        titulo: 'Detalhe da infração',
        descricao: 'Detalhamento da infração',
        props: true,
        name: 'ConsultaMultaDetalheView',
        path: '/consulta-multa/detalhe-infracao',
        component: ConsultaMultaDetalheView,
        
        meta:{
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Multa de trânsito',
                    to: '/consulta-multa'
                },
                {
                    text: 'Consulta por placa e RENAVAM',
                    to: '/consulta-multa/placa-renavam',
                },
                {
                    text: 'Detalhamento Multa',
                },
            ]
        } 
    },

    {
        titulo: 'Detalhe da infração',
        descricao: 'Detalhamento da infração',
        props: true,
        name: 'ConsultaMultaDetalheViewCpfCnpj',
        path: '/consulta-multa/detalhe-infracao',
        component: ConsultaMultaDetalheViewCpfCnpj,
        
        meta:{
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Multa de trânsito',
                    to: '/consulta-multa'
                },
                {
                    text: 'Consulta por CPF ou CNPJ do Proprietário',
                    to: '/consulta-multa/cpf-cnpj'
                },
                {
                    text: 'Detalhamento Multa',
                },
            ]
        } 
    },
    
]

export default multaRoutes